(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var htmlEle = document.documentElement;
    var c_width = document.documentElement.clientWidth > 750 ? 750 : htmlEle.clientWidth;
    htmlEle.style.fontSize = c_width / 7.5 + 'px';
  }, false);
})();